import { useMemo } from "react";
import {
  isAdminData,
  useGetEmailHubStatus,
} from "@circle-react/hooks/useGetEmailHubStatus";

export const useMarketingEmailLimits = () => {
  const { data } = useGetEmailHubStatus();

  const shouldShowEmailNotices = useMemo(() => !!isAdminData(data), [data]);

  const isSendingMarketingEmailsAllowed = useMemo(() => {
    if (!isAdminData(data)) {
      return true;
    }

    return data.limits.allowance > 0;
  }, [data]);

  const marketingHubData = useMemo(() => {
    if (isAdminData(data)) {
      return data;
    }

    return null;
  }, [data]);

  return {
    shouldShowEmailNotices,
    isSendingMarketingEmailsAllowed,
    marketingHubData,
  };
};
